import { get } from "../GenericServices";

const WorkProgressDm = {
  getDmReport: (queryString) => {
    return get(`work-progress-dm/find${queryString !== "" ? `?${queryString}` : ""}`);
  },
  downloadDmReport: (queryString) => {
    return get(`work-progress-dm/export${queryString !== "" ? `?${queryString}` : ""}`);
  },
};

export default WorkProgressDm;
